import { adaptedGoalsArrayFromSavedGoal } from '@/util/goals'
import { CONTENT_TYPES } from '@/util/access_visibility'
import { getLibraryGoal, getSharedGoal } from '@/api/library'
import TermsOfUseFooter from '@/components/library/TermsOfUseFooter'

export { savedGoalContentMixin, sharedGoalContentMixin }

function commonMixin(genericFetchGoal) {
  return {
    components: {
      TermsOfUseFooter
    },
    props: {
      uuid: {
        required: true,
        type: String
      }
    },
    data() {
      return {
        isLoading: false,
        initialSavedPage: {
          goal_uuid: '',
          uuid: '',
          subject: '',
          title: '',
          updated_at: ''
        },
        student: {
          name: null,
          uuid: null
        },
        savedGoalContentType: CONTENT_TYPES.SAVED_GOAL
      }
    },
    computed: {
      adaptedGoalsArray() {
        return adaptedGoalsArrayFromSavedGoal(this.initialSavedPage)
      }
    },
    methods: {
      async fetchLibraryGoal() {
        this.isLoading = true
        this.initialSavedPage = await genericFetchGoal(this.uuid, {
          author: true
        })
        this.isLoading = false
        this.student.name = this.initialSavedPage.student_name
        this.student.uuid = this.initialSavedPage.student_uuid
        return this.initialSavedPage
      },
      trackAdaptedGoalClick({ level, collapsed }) {
        this.$sendEvent(
          'Clicked Adapted Goal',
          {
            adapted_goal_level: level,
            level,
            collapsed
          },
          {
            ct: this.initialSavedPage.title,
            cu: this.initialSavedPage.goal_uuid
          }
        )
      }
    }
  }
}

const sharedGoalContentMixin = commonMixin(getSharedGoal)
const savedGoalContentMixin = commonMixin(getLibraryGoal)
